import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
}


export async function openFilterActivity  ({
    eventEmitter,
}: Props) {
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    eventEmitter.emit(Event.setActionBar_Visualizer)
    await sleep(50)
    eventEmitter.emit(Event.openFilterActivity)
};

